import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/logo.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "login-page" }
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = { class: "admin-white-bg admin-custom-row" }
const _hoisted_5 = { class: "admin-login-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "admin-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Admin Logo"
  })
], -1)
const _hoisted_7 = { class: "admin-login-form" }
const _hoisted_8 = { class: "login-input" }
const _hoisted_9 = { class: "password-input-container" }
const _hoisted_10 = ["type"]
const _hoisted_11 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_12 = { class: "login-input" }
const _hoisted_13 = { class: "password-input-container" }
const _hoisted_14 = ["type"]
const _hoisted_15 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_16 = {
  type: "submit",
  class: "primary-btn"
}
const _hoisted_17 = { class: "admin-login-right" }
const _hoisted_18 = { class: "admin-login-right-in" }
const _hoisted_19 = { class: "admin-site-footer" }
const _hoisted_20 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h1", null, _toDisplayString(_ctx.constants.RESET_PASSWORD_TEXT), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"])),
                id: "resetPwtForm"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.constants.PASSWORD_LABEL), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      id: "resetPwtInput",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
                      type: _ctx.showPassword ? 'text' : 'password',
                      placeholder: "Password"
                    }, null, 8, _hoisted_10), [
                      [_vModelDynamic, _ctx.password]
                    ]),
                    (!_ctx.password || _ctx.errorMsg ==='New password and confirm password do not match.')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.errorMsg), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("i", {
                      class: _normalizeClass(['password-icon', _ctx.showPassword ? 'fas fa-eye-slash' : 'fas fa-eye']),
                      id: "resetPwtIcon",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.constants.CONFIRM_PASSWORD_LABEL), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      id: "resetConPwtInput",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                      type: _ctx.showConfirmPassword ? 'text' : 'password',
                      placeholder: "Confirm Password"
                    }, null, 8, _hoisted_14), [
                      [_vModelDynamic, _ctx.confirmPassword]
                    ]),
                    (!_ctx.confirmPassword || _ctx.errorMsg ==='Link Expired.Please Send the link again.')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.errorMsg), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("i", {
                      class: _normalizeClass(['password-icon', _ctx.showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye']),
                      id: "resetPwtSubmitBtn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleConfirmPasswordVisibility && _ctx.toggleConfirmPasswordVisibility(...args)))
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.constants.RESET_PASSWORD_BUTTON), 1)
              ], 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.constants.CREATED_NEW_PASSWORD_TEXT), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.constants.YOUR_NEW_PASSWORD_MUST_BE_DIFFERENT_FROM_PREVIOUS_USED_PASSWORDS_TEXT), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ])
  ]))
}